import { select, delay, takeLatest } from 'redux-saga/effects';
import history from '@wix/da-shared-react/pkg/redux/routing/history';
import { Url } from '@wix/da-url';
import {
  setSelectedTierId,
  setSelectedTierContentType,
} from '../actions/subscriptionsSection';
import {
  getSelectedTierId,
  getSelectedTierContentType,
} from '../selectors/subscriptionsSection';
import { getProfileOwnerUser, getIsPagedMode } from '../selectors/users';
import { isSectionLoading } from '../selectors/sections';

export function* updateURLSaga() {
  if (typeof window === 'undefined') {
    return;
  }

  // debounce for fast typing
  yield delay(300);

  const isLoading: ReturnType<typeof isSectionLoading> = yield select(
    isSectionLoading
  );
  if (isLoading) {
    return;
  }
  const user: ReturnType<typeof getProfileOwnerUser> = yield select(
    getProfileOwnerUser
  );
  const tierDeviationId: NonNullable<
    ReturnType<typeof getSelectedTierId>
  > = yield select(getSelectedTierId);
  const tierContentType: ReturnType<
    typeof getSelectedTierContentType
  > = yield select(getSelectedTierContentType);
  const newUrl = Url.userSubscriptionsPath({
    username: user.username,
    tierDeviationId,
    tierContentType,
  });

  if (typeof window !== 'undefined') {
    if (window.location.pathname === newUrl) {
      // Do nothing
      return;
    }
  }

  const isPaged = yield select(getIsPagedMode);
  if (isPaged) {
    // FOLDER_DEVIATIONS module is only loaded on init/gallection
    // And we need its totalPageCount prop in order to show the pagination correctly
    if (typeof window !== 'undefined') {
      window.location.href = newUrl;
    }
  } else {
    history.push(newUrl);
  }
}

export default [
  takeLatest([setSelectedTierId, setSelectedTierContentType], updateURLSaga),
];
